
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import ConversationToolbar from './ConversationToolbar';
import ConversationMessages from './ConversationMessages';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    border: '1px solid rgba(0,0,0,0.1)'
  }
}));

function ConversationDetails({ conversation, className,getData, ...rest }) {
  const SessionUser = getUser();
  const [imageList, setImageList] = useState({})
  const [messageSenders, setMessageSenders] = useState([])
  const classes = useStyles();

  useEffect(() => {
    var messageSenders = []
    conversation.Messages.map(function (a) {
      messageSenders.push(a.Sender);
    });
    messageSenders = [...new Set(messageSenders)]
    setMessageSenders(messageSenders)
    setImageList({})
  }, [conversation]);

  useEffect(() => {
    if (messageSenders[0]) {
      GetSiriusUserImage(messageSenders[0]);
      setMessageSenders(messageSenders.filter(item => item !== messageSenders[0]))
    }
  }, [imageList]);


  const GetSiriusUserImage = (TechnicianId) => {
    const config = {
      responseType: 'blob',
    };
    axios.get(`/FileImportExport/SiriusUserImageDetail/${TechnicianId}`, config)
      .then((response) => {
        const fileURL = URL.createObjectURL(response.data);
        setImageList({ ...imageList, [TechnicianId]: fileURL })
      }).catch((error) => {
  
      });
  }
  
  return (
    <div
      className={clsx(classes.root, className)}
    >
      <ConversationToolbar conversation={conversation} />
      {imageList && <ConversationMessages getData={getData} messages={conversation.Messages} WorkOrderId={conversation.WorkOrderId} TechnicianId={SessionUser.TechnicianId} imageList={imageList} />}
    </div>
  );
}

ConversationDetails.propTypes = {
  className: PropTypes.string,
  conversation: PropTypes.object.isRequired
};

export default ConversationDetails;
